
export enum AvatarEnums {
  imageAlt = 'avatar-icon'
}

